<template>
  <div>
    <el-steps
      :active="activeStep"
      finish-status="success"
      align-center
      style="justify-content: center; margin-bottom: 20px"
    >
      <el-step title="Үндсэн мэдээлэл"></el-step>
      <el-step title="Нөхцөл"></el-step>
      <el-step title="Урамшуулал"></el-step>
    </el-steps>
    <el-form
      label-position="top"
      :model="discountForm"
      ref="discountForm"
      :rules="discountFormRules"
    >
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="20">
            <el-col :span="16">
              <div v-if="activeStep === 1" class="panelClass">
                <div class="mb20 panel-item">
                  <header>Ашиглах хэлбэр</header>
                </div>
                <div class="panel-item">
                  <el-radio-group v-model="discountForm.channel">
                    <el-radio-button :label="'ALL'">Хоёуланд нь</el-radio-button>
                    <el-radio-button v-if="isOTD" :label="'TOKTOK'">TOKTOK</el-radio-button>
                    <el-radio-button v-if="isPD" :label="'ECOMMERCE'">TOKTOKMALL</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div v-if="activeStep === 1" class="panelClass">
                <div class="mb20 panel-item">
                  <header>Урамшуулалын хэлбэр</header>
                </div>
                <div class="panel-item">
                  <el-radio-group v-model="discountForm.type">
                    <el-radio-button
                      class="block mb20"
                      v-for="type in discountTypes"
                      :key="type.value"
                      :label="type.value"
                      >{{ type.label }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </div>
              <div
                class="panelClass"
                v-if="discountForm.type === 'DISCOUNT_CODE' && activeStep === 1"
              >
                <div class="panel-item">
                  <header>Хямдралын код, Цацах суваг</header>
                </div>
                <div class="panel-item">
                  <el-form-item label="Купон код" prop="discount_code">
                    <el-input
                      v-model="discountForm.discount_code"
                      placeholder="DELIVERY_ZERO..."
                    ></el-input>
                    <span class="tip-text"
                      >Customers will enter this discount code at
                      checkout.</span
                    >
                  </el-form-item>
                  <div class="text-right">
                    <el-button type="text" @click="generateCode"
                      >Код автоматаар үүсгэх</el-button
                    >
                  </div>
                </div>
              </div>
              <div
                class="panelClass"
                v-if="activeStep === 1 && discountForm.channel === 'TOKTOK'"
              >
                <div class="panel-item">
                  <header>Захиалгын төрөл</header>
                </div>
                <div class="panel-item">
                  <el-form-item>
                    <el-radio-group
                      size="large"
                      v-model="discountForm.order_type"
                    >
                      <el-radio-button :label="'delivery'"
                        >Хүргэлтээр</el-radio-button
                      >
                      <el-radio-button :label="'pickup'"
                        >Очиж авах</el-radio-button
                      >
                      <el-radio-button :label="null"
                        >Хүргэлтээр / Очиж авах</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
              <div v-if="activeStep === 1" class="panelClass">
                <div class="panel-item">
                  <header>Урамшуулалын нэр, тайлбар</header>
                </div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="panel-item">
                      <el-form-item label="Монгол нэр" prop="title_mon">
                        <el-input
                          v-model="discountForm.title_mon"
                          placeholder="Наадам"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="panel-item">
                      <el-form-item label="Англи нэр" prop="title_eng">
                        <el-input
                          v-model="discountForm.title_eng"
                          placeholder="Naadam"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="panel-item">
                      <el-form-item label="Монгол тайлбар" prop="desc_mon">
                        <el-input
                          type="textarea"
                          v-model="discountForm.desc_mon"
                          placeholder="Энд Монгол тайлбараа бичнэ үү"
                          autosize
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="panel-item">
                      <el-form-item label="Англи тайлбар" prop="desc_eng">
                        <el-input
                          type="textarea"
                          v-model="discountForm.desc_eng"
                          placeholder="Writing to description"
                          autosize
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-if="activeStep === 2" class="panelClass">
                <div class="panel-item">
                  <header>Нөхцөл</header>
                </div>
                <div v-if="discountForm.channel === 'ALL'">
                  <div class="panel-item">
                    <el-form-item label="" style="margin-bottom: 0">
                      <el-tag style="font-size: 14px">Бүх бүтээгдэхүүн</el-tag>
                    </el-form-item>
                  </div>
                </div>
                <div v-else-if="discountForm.channel === 'TOKTOK'">
                  <conditionalFood
                    :searchProduct="searchProduct"
                    :radioState="radioState"
                    :searchPartners="searchPartners"
                    :searchService="searchService"
                    :discountForm="discountForm"
                    :discountItemTypesFood="discountItemTypesFood"
                    :allProducts="allProducts"
                    :outlets="outlets"
                    :allServices="allServices"
                  />
                </div>
                <div v-else-if="discountForm.channel === 'ECOMMERCE'">
                  <ConditionalMall
                    :discountItemTypesMall="discountItemTypesMall"
                    :discountForm.sync="discountForm"
                    :setDiscountForm="setDiscountForm"
                    :handleNodeClick="handleNodeClick"
                    :checkedNodes="checkedNodes"
                  />
                </div>
              </div>
              <div v-if="activeStep === 2" class="panelClass">
                <div class="panel-item">
                  <header>
                    Сагсан дахь худалдан авалтын бүтээгдэхүүний хязгаар
                  </header>
                </div>
                <el-row :gutter="20">
                  <el-col :span="10" class="pt20 ml20">
                    <el-form-item prop="min_item_count" label="Доод хязгаар">
                      <el-input
                        placeholder="Доод хязгаар"
                        v-model="discountForm.min_item_count"
                        type="number"
                      >
                        <template slot="append">Ш</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" class="pt20 ml20">
                    <el-form-item prop="max_item_count" label="Дээд хязгаар">
                      <el-input
                        placeholder="Дээд хязгаар"
                        v-model="discountForm.max_item_count"
                        type="number"
                      >
                        <template slot="append">Ш</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="panel-item mt20">
                  <header>Худалдан авалтын дүнгийн хязгаар</header>
                </div>
                <div class="panel-item mt20">
                  <el-radio-group
                    v-model="discountForm.minimum_requirment_type"
                  >
                    <el-radio
                      class="block mb20"
                      v-for="(type, index) in minimumRequirementTypes"
                      :key="index"
                      :label="type.value"
                      >{{ type.label }}</el-radio
                    >
                  </el-radio-group>
                  <el-form-item
                    v-if="
                      discountForm.minimum_requirment_type === 'quantity' ||
                      discountForm.minimum_requirment_type === 'amount'
                    "
                  >
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="Доод хязгаар">
                          <el-input
                            v-model="discountForm.min_pay_total"
                            type="number"
                            style="width: 200px"
                          >
                            <template slot="append">₮</template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Дээд хязгаар">
                          <el-input
                            v-model="discountForm.max_pay_total"
                            type="number"
                            style="width: 200px"
                          >
                            <template slot="append">₮</template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </div>
              </div>
              <div v-if="activeStep === 3" class="panelClass">
                <div class="panel-item">
                  <header>Урамшуулалын төрөл</header>
                </div>
                <div class="mt20">
                  <el-radio-group
                    v-model="discountForm.discount_type"
                    class="block ml30"
                  >
                    <el-radio
                      class="block mb20"
                      v-for="type in discountSubTypes"
                      :key="type.value"
                      :label="type.value"
                      @change="discountType(discountForm.discount_type)"
                      >{{ type.label }}</el-radio
                    >
                  </el-radio-group>
                </div>
                <div
                  class="panel-item"
                  v-if="
                    discountForm.discount_type === 'PERCENTAGE' ||
                    discountForm.discount_type === 'FIXED_AMOUNT'
                  "
                >
                  <el-form-item label="Хямдрах дүн" required>
                    <el-input
                      v-if="discountForm.discount_type === 'PERCENTAGE'"
                      type="number"
                      @input="persent(discountForm.discount.saled_percentage)"
                      v-model="discountForm.discount.saled_percentage"
                      style="max-width: 300px"
                    >
                      <template slot="append">%</template>
                    </el-input>
                    <el-input
                      v-if="discountForm.discount_type === 'FIXED_AMOUNT'"
                      type="number"
                      v-model="discountForm.discount.saled_price"
                      style="max-width: 300px"
                    >
                      <template slot="append">₮</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div v-if="activeStep === 3" class="panelClass">
                <div class="panel-item">
                  <header>Хэрэглээний хязгаар</header>
                </div>
                <div class="panel-item">
                  <div class="mt20">
                    <el-checkbox v-model="discountForm.usage_limit_check"
                      >Ашиглагдах купоны тоо</el-checkbox
                    >
                  </div>
                  <div class="mt10 mb20">
                    <el-input
                      v-if="discountForm.usage_limit_check"
                      type="number"
                      v-model="discountForm.usage_limit"
                      min="0"
                      class="ml30"
                      style="width: 200px"
                    ></el-input>
                  </div>
                  <div class="mt20">
                    <el-checkbox v-model="discountForm.one_user_limit"
                      >Нэг хэрэглэгч нэг л ашиглах</el-checkbox
                    >
                  </div>
                  <div class="mt20">
                    <el-checkbox v-model="discountForm.is_user_limit"
                      >Хэрэглэгчид хязгаар тавих</el-checkbox
                    >
                  </div>
                  <div class="mt10 ml20 mb20">
                    <el-radio-group
                      v-if="discountForm.is_user_limit"
                      v-model="discountForm.is_new_user"
                    >
                      <el-radio :label="1">Шинэ хэрэглэгч</el-radio>
                      <el-radio :label="0">Хуучин хэрэглэгч</el-radio>
                      <el-radio :label="2">Campaign хэрэглэчид</el-radio>
                    </el-radio-group>
                  </div>
                  <div
                    class="mt10 ml30 mb20"
                    v-if="
                      discountForm.is_new_user === 0 &&
                      discountForm.is_user_limit
                    "
                  >
                    <el-form-item prop="users" label="Утасны дугаар">
                      <el-input
                        v-model="discountForm.users"
                        type="text-area"
                        placeholder="99119911, 99999999 etc..."
                        clearable
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                  <div
                    class="ml30"
                    v-if="
                      discountForm.is_new_user === 2 &&
                      discountForm.is_user_limit
                    "
                  >
                    <el-form-item label="Campaigns" prop="campaigns">
                      <el-select
                        v-model="discountForm.campaigns"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in allCampaigns"
                          :key="item.campaign_id"
                          :label="item.name"
                          :value="item.campaign_id"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="mt20">
                    <el-checkbox v-model="discountForm.all_users"
                      >Бүх хэрэглэгч сонгох</el-checkbox
                    >
                  </div>
                </div>
              </div>
              <div class="panelClass" v-if="activeStep === 3">
                <div class="panel-item">
                  <header>Идэвхижих огноо</header>
                </div>
                <el-row :gutter="20">
                  <div class="panel-item">
                    <div
                      v-if="
                        discountForm.is_new_user === 2 &&
                        discountForm.is_user_limit
                      "
                    >
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <el-form-item label="Эхлэх огноо" prop="start_date">
                            <el-tag
                              type="info"
                              style="width: 100%; text-align: center"
                              >Campaign ажилласан огноогоор</el-tag
                            >
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Хүчинтэй өдөр" prop="start_date">
                            <el-input
                              type="number"
                              v-model="discountForm.end_date"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <el-row :gutter="5" v-else>
                      <el-col :span="8">
                        <el-form-item label="Эхлэх огноо" prop="start_date">
                          <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="discountForm.start_date"
                            type="datetime"
                            placeholder="Огноо сонгоно уу"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Дуусах огноо" prop="end_date">
                          <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="discountForm.end_date"
                            type="datetime"
                            placeholder="Огноо сонгоно уу"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-row>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="panelClass">
                <div class="panel-item">
                  <header>Мэдээлэл</header>
                  <ul class="pl20">
                    <li>Нэр: {{ discountForm.title_mon }}</li>
                    <li>Тайлбар: {{ discountForm.desc_mon }}</li>
                    <li>
                      Хэлбэр:
                      {{
                        discountTypes[
                          discountTypes.findIndex(
                            (x) => x.value === discountForm.type
                          )
                        ].label
                      }}
                    </li>
                    <li>
                      Нөхцөл:
                      <span v-if="discountForm.channel === 'TOKTOK'">{{
                        discountItemTypesFood[
                          discountItemTypesFood.findIndex(
                            (x) => x.value === discountForm.discount_item_type
                          )
                        ].label
                      }}</span>
                      <span v-else-if="discountForm.channel === 'ECOMMERCE'">{{
                        discountItemTypesMall[
                          discountItemTypesMall.findIndex(
                            (x) => x.value === discountForm.discount_item_type
                          )
                        ].label
                      }}</span>
                    </li>
                    <li v-if="discountForm.selectedCategory !== null">
                      Ангилал: {{ discountForm.selectedCategory.name_mon }}
                    </li>
                    <li v-if="discountForm.selectedOutlet.length > 0">
                      Харилцагч:
                      <span
                        v-for="outlet in discountForm.selectedOutlet"
                        :key="outlet"
                      >
                        {{ outlet.outlet_name }},
                      </span>
                    </li>
                    <li v-if="discountForm.menusByOutlet.length > 0">
                      Сонгосон бүтээгдэхүүн:
                      <span
                        v-for="product in discountForm.menusByOutlet"
                        :key="product"
                      >
                        {{ product.name_mon }},
                      </span>
                    </li>
                    <li v-if="discountForm.min_item_count !== ''">
                      Доод хязгаар: {{ discountForm.min_item_count }}
                    </li>
                    <li v-if="discountForm.max_item_count !== ''">
                      Дээд хязгаар: {{ discountForm.max_item_count }}
                    </li>
                    <li v-if="discountForm.min_pay_total !== null">
                      Үнийн дүнгийн доод хязгаар:
                      {{ discountForm.min_pay_total }}₮
                    </li>
                    <li v-if="discountForm.max_pay_total !== null">
                      Үнийн дүнгийн дээд хязгаар:
                      {{ discountForm.max_pay_total }}₮
                    </li>
                    <li>
                      Идэвхижиж эхлэх огноо: {{ discountForm.start_date }}
                    </li>
                    <li>Дуусах огноо: {{ discountForm.end_date }}</li>
                    <li>
                      Төрөл:
                      {{
                        discountSubTypes[
                          discountSubTypes.findIndex(
                            (x) => x.value === discountForm.discount_type
                          )
                        ].label
                      }}
                      <span
                        v-if="
                          discountForm.discount_type === 'PERCENTAGE' ||
                          discountForm.discount_type === 'FIXED_AMOUNT'
                        "
                        >{{
                          discountForm.discount_type === "FIXED_AMOUNT"
                            ? discountForm.discount.saled_price
                            : discountForm.discount.saled_percentage
                        }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="text-right border-top pt20">
                <router-link to="/discount-list">
                  <el-button
                    type="default"
                    class="mr10"
                    size="mini"
                    style="font-size: 0.8vw"
                    >Болих</el-button
                  >
                </router-link>
                <el-button
                  v-if="activeStep > 1"
                  type="warning"
                  @click="prevStep"
                  icon="el-icon-arrow-left"
                  size="mini"
                  style="font-size: 0.8vw"
                  >Өмнөх</el-button
                >
                <el-button
                  v-if="activeStep < 3"
                  type="primary"
                  @click="nextStep"
                  size="mini"
                  style="font-size: 0.8vw"
                  >Дараах <i class="el-icon-arrow-right el-icon-right"></i
                ></el-button>
                <el-button
                  v-if="activeStep === 3"
                  :disabled="isDisabled"
                  type="success"
                  @click="saveDiscount('discountForm')"
                  size="mini"
                  style="font-size: 0.8vw"
                  >Хадгалах</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import helper from '../../helpers/helper'
import services from '../../helpers/services'
import conditionalFood from '@/components/discount/components/conditionalFood'
import ConditionalMall from './components/conditionalMall.vue'
import { getGroups } from '../../utils/auth'
export default {
  name: 'addDiscountFood',
  components: {
    conditionalFood,
    ConditionalMall
  },
  data () {
    return {
      outlets: [],
      isDisabled: false,
      activeStep: 1,
      min_count: null,
      max_count: null,
      usedCoupon: [
        {
          value: 'ALL',
          label: 'Хоёуланд нь'
        },
        {
          value: 'TOKTOK',
          label: 'TOKTOK'
        },
        {
          value: 'ECOMMERCE',
          label: 'TOKTOKMALL'
        }
      ],
      discountTypes: [
        {
          value: 'DISCOUNT_CODE',
          label: 'Купон код'
        },
        {
          value: 'AUTO',
          label: 'Автоматаар бодогдох'
        }
      ],
      discountSubTypes: [
        {
          value: 'PERCENTAGE',
          label: 'Хувиар %'
        },
        {
          value: 'FIXED_AMOUNT',
          label: 'Үнийн дүнгээр'
        },
        {
          value: 'FREE_DELIVERY',
          label: 'Хүргэлтийн үнэ'
        }
      ],
      discountItemTypesFood: [
        {
          value: 'all_product',
          label: 'Бүх бүтээгдэхүүн'
        },
        {
          value: 'service',
          label: 'Бүх ангилал'
        },
        {
          value: 'partners',
          label: 'Харилцагчаас'
        },
        {
          value: 'specific_product',
          label: 'Сонгосон бүтээгдэхүүн'
        }
      ],
      discountItemTypesMall: [
        {
          value: 'all_product',
          label: 'Бүх бүтээгдэхүүн'
        },
        {
          value: 'specific_product',
          label: 'Сонгосон бүтээгдэхүүн'
        },
        {
          value: 'category',
          label: 'Сонгосон ангилалын бүх бүтээгдэхүүн'
        },
        {
          value: 'supplier',
          label: 'Сонгосон нийлүүлэгчийн бүх бүтээгдэхүүн'
        },
        {
          value: 'brand',
          label: 'Сонгосон брендийн бүх бүтээгдэхүүн'
        }
      ],
      minimumRequirementTypes: [
        {
          value: 'none',
          label: 'Шаардлагагүй'
        },
        {
          value: 'amount',
          label: ' Тохируулах'
        }
      ],
      discountForm: {
        type: 'DISCOUNT_CODE',
        max_item_count: '',
        min_item_count: '',
        min_count: '',
        max_count: '',
        title_mon: '',
        title_eng: '',
        desc_mon: '',
        desc_eng: '',
        channel: 'ALL',
        discount_code: '',
        discount_type: 'PERCENTAGE',
        min_pay_total: null,
        max_pay_total: null,
        discount: {
          saled_percentage: null,
          free_delivery: null,
          saled_price: null
        },
        freeProducts: [],
        toktok_products: [],
        toktok_services: [],
        toktok_partners: [],
        discount_item_type: 'all_product',
        minimum_requirment_type: 'none',
        discount_user_type: 'all',
        users: [],
        usage_limit_check: 0,
        usage_limit: 0,
        one_user_limit: 0,
        start_date: new Date(),
        end_date: null,
        // set_end_date: true,
        selectedCategory: null,
        selectedOutlet: [],
        outlet_name: '',
        menusByOutlet: [],
        is_user_limit: 0,
        user_limit: 0,
        is_new_user: 0,
        all_users: 0,
        products: [],
        suppliers: [],
        brands: [],
        categories: [],
        order_type: null,
        campaigns: []
      },
      discountFormRules: {
        type: [
          {
            required: true,
            message: 'Хямдралийн төрөл сонгоно уу',
            trigger: 'blur'
          }
        ],
        discount_code: [
          {
            required: true,
            message: 'Хямдралийн код оруулна уу',
            trigger: ['blur', 'change']
          }
        ],
        title_mon: [
          { required: true, message: 'Монгол нэр оруулна уу', trigger: 'blur' }
        ],
        title_eng: [
          { required: true, message: 'Англи нэр оруулна уу?', trigger: 'blur' }
        ],
        desc_mon: [
          {
            required: true,
            message: 'Монгол тайлбар оруулна уу',
            trigger: 'blur'
          }
        ],
        desc_eng: [
          {
            required: true,
            message: 'Англи тайлбар оруулна уу',
            trigger: 'blur'
          }
        ],
        min_item_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        max_item_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        selectedCategory: [
          {
            required: true,
            message: 'Ангилал сонгоогүй байна!!!',
            trigger: 'blur'
          }
        ],
        selectedOutlet: [
          {
            required: true,
            message: 'Харилцагч сонгоогүй байна!!!',
            trigger: 'blur'
          }
        ],
        outlet_name: [
          {
            required: true,
            message: 'Харилцагч сонгоогүй байна!!!',
            trigger: 'blur'
          }
        ],
        menusByOutlet: [
          {
            required: true,
            message: 'Бүтээгдэхүүн сонгоогүй байна!!!',
            trigger: 'blur'
          }
        ],
        users: [
          {
            required: true,
            message: 'Утасны дугаар бичээгүй байна!!!',
            trigger: 'blur'
          }
        ],
        start_date: [
          {
            required: true,
            message: 'Эхлэх хугацааг оруулна уу !!!',
            trigger: 'blur'
          }
        ],
        end_date: [
          {
            required: true,
            message: 'Дуусах хугацааг оруулна уу !!!',
            trigger: 'blur'
          }
        ]
      },
      allServices: [],
      allProducts: [],
      allCampaigns: [],
      loading: false,
      timer: null,
      checkedNodes: null,
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.valueOf() - 1000 * 60 * 60 * 24
        }
      },
      categories: [],
      treeDefaultProps: {
        children: 'childrens',
        label: 'name_mon'
      },
      role: [],
      isOTD: false,
      isPD: false
    }
  },

  created () {
    this.checkRole()
    this.getOutletName()
    this.getServices()
    this.getProducts()
    this.getCampaigns('')
    // if (this.$route.query.type === 'DISCOUNT_CODE') {
    //   this.discountForm.type = 'DISCOUNT_CODE'
    // } else {
    //   this.discountForm.type = 'AUTO'
    // }
  },
  watch: {
    discountForm: {
      deep: true,
      handler (data) {
        if (data.is_new_user === 2) {
          this.discountForm.start_date = 'CAMPAIGN'
        }
      }
    }
  },
  methods: {
    getCategories () {
      this.loading = true
      services.getCategories().then((response) => {
        this.categories = response
        this.loading = false
      })
    },
    async getCampaigns (searchText) {
      const res = await services.getCampaigns(searchText)
      if (res.status === 'success' && res.data) {
        this.allCampaigns = res.data
      }
    },
    async searchProduct (text) {
      if (text !== '' && text !== undefined) {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getProducts(text), 1000)
        this.loading = false
      } else if (text === '') {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getProducts((text = '')), 1000)
        this.loading = false
      }
    },
    searchService (text) {
      if (text !== '' && text !== undefined) {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getServices(text), 1000)
        this.loading = false
      } else if (text === '') {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getServices((text = '')), 1000)
        this.loading = false
      }
    },
    searchPartners (text) {
      if (text !== '' && text !== undefined) {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getOutletName(text), 1000)
        this.loading = false
      } else if (text === '') {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getOutletName((text = '')), 1000)
        this.loading = false
      }
    },
    getProducts (text = '') {
      services.getProductsApp(text).then((response) => {
        this.allProducts = response.datas
      })
    },
    getServices (text = '') {
      services.getServicesApp(text).then((response) => {
        if (response.status === 'success') {
          this.allServices = response.services
        }
      })
    },
    getOutletName (text = '') {
      services.getSuppliersApp(text).then((response) => {
        if (Array.isArray(response.datas)) {
          this.outlets = response.datas
        }
      })
    },
    prevStep () {
      this.activeStep--
    },

    nextStep () {
      if (this.activeStep === 1) {
        this.$refs.discountForm.validate((valid) => {
          if (valid) {
            this.activeStep++
          } else {
            this.$notify({
              title: 'Анхааруулга',
              message: 'Шаардлагатай талбаруудыг бөглөөгүй байна!!!',
              type: 'warning'
            })
          }
        })
      } else if (this.activeStep === 2 && this.discountForm.channel === 'TOKTOK') {
        this.$refs.discountForm.validate((valid) => {
          if (valid) {
            if (
              parseInt(this.discountForm.min_item_count) >
              parseInt(this.discountForm.max_item_count)
            ) {
              return this.$notify({
                title: 'Анхааруулга',
                message: 'Дээд хязгаар нь доод хязгаараас бага байх ёсгүй!!!',
                type: 'warning'
              })
            }
            if (this.discountForm.selectedCategory !== null) {
              if (
                [undefined, '', null].includes(this.discountForm.max_count) ||
                [undefined, '', null].includes(this.discountForm.min_count)
              ) {
                return this.$notify({
                  title: 'Анхааруулга',
                  message: 'Ангилалын дээд эсвэл доод хязгаар хоосон байна!!!',
                  type: 'warning'
                })
              }
            }
            if (this.discountForm.discount_item_type === 'specific_product') {
              const tempProduct = []
              this.discountForm.menusByOutlet.forEach((product) => {
                tempProduct.push({
                  pkey: product.pkey,
                  img_url: product.img_url,
                  min_count: product.min_count,
                  max_count: product.max_count,
                  name_mon: product.name_mon,
                  name_eng: product.name_eng
                })
              })
              this.discountForm.toktok_products = tempProduct
            } else if (this.discountForm.discount_item_type === 'service') {
              const tempCategories = []
              tempCategories.push({
                image: this.discountForm.selectedCategory.img_url,
                min_count: this.discountForm.min_count,
                max_count: this.discountForm.max_count,
                name_eng: this.discountForm.selectedCategory.name_eng,
                name_mon: this.discountForm.selectedCategory.name_mon
              })
              this.discountForm.toktok_services = tempCategories
            } else if (this.discountForm.discount_item_type === 'partners') {
              const tempSuppliers = []
              this.discountForm.selectedOutlet.forEach((supplier) => {
                tempSuppliers.push({
                  outlet_id: supplier.outlet_id,
                  outlet_name: supplier.outlet_name,
                  min_count: supplier.min_count,
                  max_count: supplier.max_count
                })
              })
              this.discountForm.toktok_partners = tempSuppliers
            }
            this.activeStep++
          } else {
            this.$notify({
              title: 'Анхааруулга',
              message: 'Шаардлагатай талбаруудыг бөглөөгүй байна!!!',
              type: 'warning'
            })
          }
        })
      } else if (this.activeStep === 2 && this.discountForm.channel === 'ECOMMERCE') {
        this.$refs.discountForm.validate((valid) => {
          if (valid) {
            if (parseInt(this.discountForm.min_item_count) > parseInt(this.discountForm.max_item_count)) {
              return this.$notify({
                title: 'Анхааруулга',
                message: 'Дээд хязгаар нь доод хязгаараас бага байх ёсгүй!!!',
                type: 'warning'
              })
            }
            if (this.discountForm.max_item_count === 0) {
              return this.$notify({
                title: 'Анхааруулга',
                message: 'Сагсан дахь бүтээгдэхүүний дээд хязгаар 0 байж болохгүй!!!',
                type: 'warning'
              })
            }
            if (this.discountForm.discount_item_type === 'specific_product') {
              const tempProduct = []
              if (this.discountForm.products.length > 0) {
                this.discountForm.products.forEach((product) => {
                  product.variants.forEach((variant) => {
                    tempProduct.push({
                      product_id: variant.product_id,
                      variant_id: variant.variant_id,
                      min_count: variant.min_count,
                      max_count: variant.max_count
                    })
                  })
                })
                this.discountForm.products = tempProduct
                this.discountForm.categories = null
                this.discountForm.suppliers = null
                this.discountForm.brands = null
              } else {
                return this.$notify({
                  title: 'Анхааруулга',
                  message: 'Бүтээгдэхүүн сонгоогүй байна!!!',
                  type: 'warning'
                })
              }
            } else if (this.discountForm.discount_item_type === 'category') {
              const tempCategories = []
              if (this.checkedNodes !== null) {
                tempCategories.push({
                  category_id: this.checkedNodes.uniq_id,
                  childrens: this.checkedNodes.childrens ? this.checkedNodes.childrens : [],
                  min_count: this.discountForm.category_min_count,
                  max_count: this.discountForm.category_max_count
                })
                this.discountForm.categories = tempCategories
                this.discountForm.products = []
                this.discountForm.suppliers = null
                this.discountForm.brands = null
              } else {
                return this.$notify({
                  title: 'Анхааруулга',
                  message: 'Ангилал сонгоогүй байна!!!',
                  type: 'warning'
                })
              }
            } else if (this.discountForm.discount_item_type === 'supplier') {
              const tempSuppliers = []
              if (this.discountForm.suppliers !== null) {
                tempSuppliers.push({
                  supplier_id: this.discountForm.suppliers.supplier_id,
                  min_count: this.discountForm.supplier_min_count,
                  max_count: this.discountForm.supplier_max_count
                })
                this.discountForm.categories = null
                this.discountForm.products = []
                this.discountForm.suppliers = tempSuppliers
                this.discountForm.brands = null
              } else {
                return this.$notify({
                  title: 'Анхааруулга',
                  message: 'Нийлүүлэгч сонгоогүй байна!!!',
                  type: 'warning'
                })
              }
            } else if (this.discountForm.discount_item_type === 'brand') {
              const tempBrands = []
              if (this.discountForm.brands !== null) {
                tempBrands.push({
                  brand_id: this.discountForm.brands.brand_id,
                  min_count: this.discountForm.brand_min_count,
                  max_count: this.discountForm.brand_max_count
                })
                this.discountForm.categories = null
                this.discountForm.products = []
                this.discountForm.suppliers = null
                this.discountForm.brands = tempBrands
              } else {
                return this.$notify({
                  title: 'Анхааруулга',
                  message: 'Бренд сонгоогүй байна!!!',
                  type: 'warning'
                })
              }
            }
            this.activeStep++
          } else {
            this.$notify({
              title: 'Анхааруулга',
              message: 'Шаардлагатай талбаруудыг бөглөөгүй байна!!!',
              type: 'warning'
            })
          }
        })
      } else {
        this.activeStep++
      }
    },
    radioState (data) {
      if (data === 'specific_product') {
        this.discountForm.selectedCategory = null
        this.discountForm.selectedOutlet = []
      } else if (data === 'service') {
        this.discountForm.selectedOutlet = []
        this.discountForm.outlet_name = ''
        this.discountForm.menusByOutlet = []
      } else if (data === 'partners') {
        this.discountForm.selectedCategory = null
        // this.discountForm.outlet_name = ''
        this.discountFormmenusByOutlet = []
      } else if (data === 'all_product') {
        this.discountForm.selectedCategory = null
        this.discountForm.outlet_name = ''
        this.discountForm.selectedOutlet = []
        this.discountForm.menusByOutlet = []
      }
    },
    generateCode () {
      const code = helper.generateDiscountCode()
      this.discountForm.discount_code = code
    },
    handleNodeClick (data) {
      this.checkedNodes = data
    },
    discountType (data) {
      if (data === 'PERCENTAGE') {
        this.discountForm.discount.saled_price = 0
      } else if (data === 'FIXED_AMOUNT') {
        this.discountForm.discount.saled_percentage = null
      } else if (data === 'FREE_DELIVERY') {
        this.discountForm.discount.saled_price = 0
        this.discountForm.discount.saled_percentage = null
      }
    },
    persent (data) {
      if (data > 100) {
        this.discountForm.discount.saled_percentage = 100
      }
    },
    saveDiscount (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true
          const tempData = JSON.parse(JSON.stringify(this.discountForm))
          tempData.start_date = tempData.start_date
            .slice(0, 19)
            .replace('T', ' ')
          if (tempData.end_date) {
            tempData.end_date = tempData.end_date
              .slice(0, 19)
              .replace('T', ' ')
          }
          if (tempData.usage_limit === 0) {
            tempData.usage_limit = null
          } else {
            tempData.usage_limit = parseInt(tempData.usage_limit)
          }
          if (tempData.min_pay_total === 0) {
            tempData.min_pay_total = null
          } else {
            tempData.min_pay_total = parseInt(tempData.min_pay_total)
          }
          if (tempData.max_pay_total === 0) {
            tempData.max_pay_total = null
          } else {
            tempData.max_pay_total = parseInt(tempData.max_pay_total)
          }
          if (tempData.users.length > 0) {
            tempData.users = tempData.users
              .split(/[\s,]+/)
              .map((el) => parseInt(el))
          }
          tempData.min_item_count = parseInt(tempData.min_item_count)
          tempData.max_item_count = parseInt(tempData.max_item_count)
          if (
            tempData.is_user_limit === 0 ||
            tempData.is_user_limit === false
          ) {
            tempData.is_new_user = 0
            tempData.users = []
            tempData.is_user_limit = 0
          } else {
            tempData.is_user_limit = 1
          }
          if (tempData.one_user_limit === true) {
            tempData.one_user_limit = 1
          } else {
            tempData.one_user_limit = 0
          }
          if (this.discountForm.type === 'AUTO') {
            const discountCode = helper.generateDiscountCode()
            tempData.discount_code = discountCode
          }
          if (tempData.is_new_user === 1) {
            tempData.users = []
          }
          if (tempData.all_users === true) {
            tempData.all_users = 1
          } else {
            tempData.all_users = 0
          }
          services.addDiscount(tempData).then((response) => {
            this.$notify({
              title: response.status === 'success' ? 'Амжилттай' : 'Уучлаарай',
              message: response.message,
              type: response.status
            })
            if (response.status === 'success') {
              this.$router.push({ name: 'discounts' })
            } else {
              this.isDisabled = false
            }
          })
        } else {
          return false
        }
      })
    },
    setDiscountForm (data) {
      this.discountForm = data
    },
    async checkRole () {
      await getGroups().then(group => {
        group.forEach(response => {
          if (['boss', 'Marketing', 'view'].includes(response)) {
            this.isOTD = true
            this.isPD = true
          } else if (['OTD'].includes(response)) {
            this.isOTD = true
            this.isPD = false
          } else if (['PD'].includes(response)) {
            this.isOTD = false
            this.isPD = true
          }
        })
      })
    }
  }
}
</script>
